import { ImageCardProps } from "@/utils/types";
import Link from "next/link";
import { ImageObject } from "./ImageObject";

export const ImageCard = ({
  className,
  componentId,
  image,
  lightMode,
  copy,
  href,
}: ImageCardProps) => {
  const isExternal =
    href && (href.startsWith("http://") || href.startsWith("https://"));
  return (
    <div
      id={componentId}
      className={`imageCard relative w-83.5 h-111.5 ${className ? ` ${className}` : ""}`}
    >
      {href && (
        <Link
          href={href}
          target={isExternal ? "_blank" : undefined}
          rel={isExternal ? "noreferrer noopener" : undefined}
          className={`border-[3px] relative h-full scale-100 w-full ${lightMode ? "border-white" : "border-secondary"} hover:border-secondaryShade rounded-[24px] md:rounded-card  overflow-hidden flex flex-col justify-end pb-10 duration-[0.1s] items-center`}
        >
          {image && (
            <ImageObject
              {...image}
              imageWidth={800}
              className="object-cover absolute w-full h-full top-0 left-0"
            />
          )}
          <p className="button-vis secondary relative z-10">{copy}</p>
        </Link>
      )}
    </div>
  );
};
